import { Box, styled } from '@planne-software/uni/mui/material';

export const TimeGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(5, minmax(0, 1fr))',
  gap: theme.tokens.spacing['spacing-1xmini'],
}));
